import { ProjectBusinessComponent, ProjectBusinessPurpose } from '@neo.tax/shared';

export const BUSINESS_COMPONENT_OPTIONS = [
  {
    value: ProjectBusinessComponent.ComputerSoftware,
    label: 'Software',
  },
  {
    value: ProjectBusinessComponent.Product,
    label: 'Physical Product',
  },
  {
    value: ProjectBusinessComponent.Process,
    label: 'Process (e.g. Manufacturing)',
  },
];

export const BUSINESS_PURPOSE_OPTIONS = [
  {
    value: ProjectBusinessPurpose.SaleOrLease,
    label: 'Sale/Lease to Customers',
  },
  {
    value: ProjectBusinessPurpose.InternalUse,
    label: 'Internal Use only',
  },
];
